import type Department from '../../offices/models/department/department';
import type RoomObsolete from '../../offices/models/room/room-obsolete';

export enum DayPart {
  Morning,
  Afternoon,
}

export class DayPartEntries {
  id?: string;

  room?: RoomObsolete;

  department?: Department;

  dayPart?: DayPart;

  roomId?: string;

  departmentId?: string;

  workplaceId?: string;
}
